import React from 'react';
import { feedback } from '@ecosystem/newron-design-system';

export type LoadPeriodsProps = {
  loading: boolean;
};

const LoadWrapper: React.FC<LoadPeriodsProps> = ({ children, loading }) => {
  if (loading) return <feedback.DotsLoader testId="loading" />;
  return <>{children}</>;
};

export default LoadWrapper;
